export default __webpack_public_path__ + "static/service_general_office@2x-1cad3ead5e888b816a02ec702476b03b.jpg";